<script>
export default {
  name: 'ImageGallery',

  props: {
    onInstallPage: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentImage: 'HomeScreenshot',
      images: [
        'HomeScreenshot',
        'DeepeningCategoryScreenshot',
        'DeepeningCardScreenshot',
        'JourneyCategoryScreenshot',
        'JourneyCardScreenshot',
        'LighteningCategoryScreenshot',
        'LighteningCardScreenshot',
      ],
    };
  },

  methods: {
    setcurrentImage(image = '') {
      this.currentImage = image;
      this.$store.dispatch('analytics/appScreenshotView', image);
    },
  },
};
</script>

<template>
  <v-lazy>
    <div class="gallery-container" :class="{ 'install-page': onInstallPage }">
      <div class="current-container">
        <div class="device-frame">
          <picture>
            <source :srcset="require('@/assets/images/Pixel3Frame-1540h.webp')" type="image/webp" />
            <source :srcset="require('@/assets/images/Pixel3Frame-1540h.png')" type="image/png" />
            <img :src="require('@/assets/images/Pixel3Frame-1540h.png')" alt="App Screenshot" />
          </picture>
        </div>
        <div class="current-image">
          <picture>
            <source
              :srcset="require(`@/assets/images/${currentImage}-1250h.webp`)"
              type="image/webp"
            />
            <source
              :srcset="require(`@/assets/images/${currentImage}-1250h.png`)"
              type="image/png"
            />
            <img :src="require(`@/assets/images/${currentImage}-1250h.png`)" alt="App Screenshot" />
          </picture>
        </div>
      </div>

      <div class="thumbnail-container">
        <div v-for="image in images" :key="image" class="thumbnail">
          <div
            class="thumbnail-image"
            @click="setcurrentImage(image)"
            @mouseover="setcurrentImage(image)"
          >
            <picture>
              <source :srcset="require(`@/assets/images/${image}-1250h.webp`)" type="image/webp" />
              <source :srcset="require(`@/assets/images/${image}-1250h.png`)" type="image/png" />
              <img :src="require(`@/assets/images/${image}-1250h.png`)" alt="App Screenshot" />
            </picture>
          </div>

          <transition name="fade">
            <div v-show="image === currentImage" class="current-indicator" />
          </transition>
        </div>
      </div>
    </div>
  </v-lazy>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.gallery-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .sm & {
    align-items: flex-start;
    width: 100%;
    max-width: 100%;
    padding: 0 1.5rem;
    box-sizing: border-box;
  }
}

.thumbnail-container {
  display: flex;
  overflow-x: scroll;
  margin: 1rem 0;
  max-width: 100%;
}

.thumbnail {
  height: fit-content;
  width: fit-content;
  margin: 0 2px;
}

.thumbnail-image {
  height: 120px;
  min-width: 60px;
  width: 60px;
  cursor: pointer;

  img {
    height: 100%;
    width: auto;
    border-radius: 4px;
  }

  .sm & {
    height: 160px;
    min-width: 80px;
    width: 80px;

    img {
      border-radius: 6px;
    }
  }
}

.current-indicator {
  // width: 100%;
  height: 4px;
  margin-top: 10px;
  background-color: $blue-light;
}

.current-container,
.device-frame {
  width: 320px;
}

.current-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;

  .sm & {
    width: 100%;
    max-width: 100%;
  }
}

.device-frame {
  position: absolute;
  top: 0;
  left: 0;
  height: auto;
  z-index: 10;

  .sm & {
    width: 100%;
    max-width: 100%;
  }
}
.current-image {
  margin: 18% 7%;
}

.install-page {
  .lg & {
    .current-container,
    .device-frame {
      width: 200px;
    }

    .thumbnail-image {
      height: 60px;
      min-width: 30px;
      width: 30px;

      img {
        border-radius: 3px;
      }
    }
  }

  .xl & {
    .current-container,
    .device-frame {
      width: 260px;
    }

    .thumbnail-image {
      height: 80px;
      min-width: 40px;
      width: 40px;

      img {
        border-radius: 4px;
      }
    }
  }
}

.fade-enter-active {
  transition: all 0.5s ease;
}
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
